<template>
  <div>
    <v-select
      v-model="entitySelectMode"
      class="input-max-width"
      :items="entitySelectModes"
      hide-details
    />
    <br>
    <template v-if="entitySelectMode === 1">
      <v-row>
        <v-col
          cols="8"
          sm="6"
          md="3"
        >
          <v-autocomplete
            v-model="entityModel"
            :items="groupEntitiesForSelect"
            :item-text="item => item.entityAbbr +' - '+ $chPtObjData('entityChinName', item)"
            hide-details
            item-value="id"
            :label="$t('Outbox.ReceiveDept')"
          />
        </v-col>
        <v-col
          cols="4"
          sm="8"
          md="9"
        >
          <v-btn
            class="mt-2"
            @click="addEntity(entityModel)"
          >
            {{ $t('PublicServant.Action.New') }}
          </v-btn>
        </v-col>
      </v-row>
    </template>

    <template v-if="entitySelectMode === 2">
      <v-treeview
        v-model="local.watchProps.selectedEntities"
        :items="entitiesTree"
        dense
        selectable
        open-on-click
      />
    </template>

    <template v-if="local.watchProps.selectedEntities.length">
      <div v-if="entitySelectMode === 1">
        <div
          v-for="entityId in local.watchProps.selectedEntities"
          :key="entityId"
        >
          <v-btn
            text
            icon
            x-small
            color="red"
            class="mr-2"
          >
            <v-icon @click="removeEntity(entityId)">
              {{ mdiMinusCircleOutline }}
            </v-icon>
          </v-btn>
          {{ getEntityDesc(entityId) }}
        </div>
      </div>
      <div>
        {{ $t('Text.Sum') }}: {{ local.watchProps.selectedEntities.length }}
      </div>
    </template>
    <v-sheet
      v-else
      color="yellow lighten-3 grey--text text--darken-2"
      max-width="600"
      class="pa-3"
    >
      {{ $t('Outbox.NoDept') }}
    </v-sheet>

    <br>
    <v-btn
      v-if="!local.isEncryptDoc"
      depressed
      @click="showCopyHandler"
    >
      {{ $t('Outbox.CC') }}
      <v-icon>{{ mdiMenuDown }}</v-icon>
    </v-btn>

    <div
      v-if="isShowCopy"
      style="border: 5px solid #f5f5f5"
      class="pa-4"
    >
      <v-row>
        <v-col
          cols="8"
          sm="6"
          md="3"
        >
          <v-autocomplete
            v-model="entityModel"
            :items="entities"
            :item-text="item => item.abbr +' - '+ $chPtObjData('chinName', item)"
            hide-details
            item-value="id"
            :label="$t('Outbox.CCDept')"
          />
        </v-col>
        <v-col
          cols="4"
          sm="8"
          md="9"
        >
          <v-btn
            class="mt-2"
            outlined
            @click="addCCEntity(entityModel)"
          >
            {{ $t('PublicServant.Action.New') }}
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="local.watchProps.ccEntities.length">
        <div
          v-for="entityId in local.watchProps.ccEntities"
          :key="entityId"
        >
          <v-btn
            text
            icon
            x-small
            color="red"
            class="mr-2"
          >
            <v-icon @click="removeCCEntity(entityId)">
              {{ mdiMinusCircleOutline }}
            </v-icon>
          </v-btn>
          {{ getCCEntity(entityId).abbr +' - '+ $chPtObjData('chinName', getCCEntity(entityId)) }}
        </div>
        <div>
          {{ $t('Text.Sum') }}: {{ local.watchProps.ccEntities.length }}
        </div>
      </template>
      <v-sheet
        v-else
        color="yellow lighten-3 grey--text text--darken-2"
        max-width="600"
        class="pa-3"
      >
        {{ $t('Outbox.NoCCDept') }}
      </v-sheet>
      <v-switch
        v-model="local.isCarbonCopyAttachments "
        :label="$t('Outbox.isCCAttachments')"
        class="d-inline-block"
      />
      <v-sheet
        v-show="selectedEntityObjs.length > 1"
        max-width="600"
      >
        <v-autocomplete
          v-model="local.carbonCopyFromEntityId"
          :items="selectedEntityObjs"
          :item-text="item => item.abbr +' - '+ $chPtObjData('chinName', item)"
          hide-details
          item-value="id"
          :label="$t('Outbox.CCFromEntity')"
        />
      </v-sheet>
    </div>
  </div>
</template>

<script>

import { OUTBOX_ENTITY_SOURCE_TYPE } from '@/constant/constant'
import outboxApi from '@/api/outbox/outbox'
import { staffModule } from '@/store/moduleName'
// import objectUtil from '@/utils/objectUtil'
import { mapState } from 'vuex'
import { mdiMinusCircleOutline, mdiMenuDown } from '@mdi/js'

function setSelectedEntities (inst) {
  if (inst.prefilledForm) {
    inst.prefilledForm.details.forEach(entity => {
      inst.groupEntitiesForSelect.some(item => {
        if (entity.receiveEntityId === item.entityId) {
          inst.value.watchProps.selectedEntities.push(item.id)
          return true
        }
      })
    })
  }
}

function genEntitiesTree (inst) {
  inst.entitiesTree = []
  inst.entityGroups.forEach(itemG => {
    let group = {
      id: itemG.entityGroupId,
      name: inst.$chPtObjData('entityGroupChinName', itemG),
      children: []
    }
    itemG.entities.forEach(item => {
      // if (item.entityId !== objectUtil.get(inst, 'staff.entityId')) {
      let entity = {
        id: itemG.entityGroupId + '-' + item.entityId,
        name: item.entityAbbr + ' - ' + inst.$chPtObjData('entityChinName', item)
      }
      group.children.push(entity)
      // }
    })
    if (group.children.length > 0) {
      inst.entitiesTree.push(group)
    }
  })
}

function genGroupEntities (inst) {
  inst.value.groupEntities = []
  inst.entityGroups.forEach(itemG => {
    itemG.entities.forEach(item => {
      let entity = {
        id: item.entityId,
        abbr: item.entityAbbr,
        chinName: item.entityChinName,
        portName: item.entityPortName
      }
      inst.value.groupEntities.push(entity)
    })
  })
}

function getEntityGroups (inst) {
  outboxApi.getEntityGroupItems(OUTBOX_ENTITY_SOURCE_TYPE.APM, resp => {
    if (resp.status === 201 || resp.status === 200) {
      inst.entityGroups = resp.data
      setSelectedEntities(inst)
      genEntitiesTree(inst)
      genGroupEntities(inst)
    }
  })
}

export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    entities: {
      type: Array,
      default: null
    },
    selectedEntityObjs: {
      type: Array,
      default: null
    },
    prefilledForm: {
      type: Object,
      default: null
    }
  },
  data: () => {
    return {
      mdiMinusCircleOutline: mdiMinusCircleOutline,
      mdiMenuDown: mdiMenuDown,
      entityGroups: null,
      entitySelectMode: 2, // tree mode or list mode
      entityModel: null, // temp entity data using in select
      isShowCopy: false,
      entitiesTree: []
    }
  },
  computed: {
    ...mapState({
      staff: state => state[staffModule].info
    }),
    local () {
      return this.value ? this.value : {
        watchProps: {
          selectedEntities: []
        }
      }
    },
    locale () {
      return this.$i18n.locale
    },
    groupEntitiesForSelect () {
      let result = []
      this.entityGroups.forEach(itemG => {
        itemG.entities.forEach(item => {
          // if (item.entityId !== objectUtil.get(this, 'staff.entityId')) {
          let entity = { ...item }
          entity.id = itemG.entityGroupId + '-' + item.entityId
          entity.groupId = itemG.entityGroupId
          entity.entityGroupChinName = itemG.entityGroupChinName
          entity.entityGroupPortName = itemG.entityGroupPortName
          result.push(entity)
          // }
        })
      })
      return result
    },
    entitySelectModes () {
      return [
        { value: 1, text: this.$t('Outbox.ReceiveEntity.SelectMode.Direct') },
        { value: 2, text: this.$t('Outbox.ReceiveEntity.SelectMode.Tree') }
      ]
    }
    // selectedEntityIds () {
    //   return this.local.watchProps.selectedEntities.map(id => {
    //     let arr = id.toString().split('-')
    //     return arr[arr.length - 1]
    //   })
    // }
  },
  watch: {
    'local.isEncryptDoc': function (val) {
      this.isShowCopy = false
    },
    locale: function (val) {
      genEntitiesTree(this)
    },
    selectedEntityObjs: function (val) {
      if (val.length === 1) {
        this.local.carbonCopyFromEntityId = val[0].id
      } else if (this.local.carbonCopyFromEntityId) {
        let found = val.some(entity => {
          if (entity.id === this.local.carbonCopyFromEntityId) {
            return true
          }
        })
        if (!found) {
          this.local.carbonCopyFromEntityId = null
        }
      }
    }
  },
  async created () {
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    getEntityGroups(this)
  },
  methods: {
    selectEntity (entityId) {
      let found = this.value.watchProps.selectedEntities.some(entity => {
        if (parseInt(entity.split('-')[1]) === entityId) {
          return true
        }
      })
      if (!found) {
        let temp = this.groupEntitiesForSelect.find(entity => {
          return entity.entityId === entityId
        })
        if (temp) {
          this.value.watchProps.selectedEntities.push(temp.id)
        }
      }
    },
    addEntity (val) {
      if (this.local.watchProps.selectedEntities.includes(val)) {
        return
      }
      let newSelectedEntities = [...this.local.watchProps.selectedEntities, val]
      let newWatchProps = { ...this.local.watchProps, selectedEntities: newSelectedEntities }
      this.$emit('input', { ...this.local, watchProps: newWatchProps })
    },
    removeEntity (val) {
      let selectedEntitiesCopy = [...this.local.watchProps.selectedEntities]
      const index = selectedEntitiesCopy.indexOf(val)
      if (index > -1) {
        selectedEntitiesCopy.splice(index, 1)
      }

      let newWatchProps = { ...this.local.watchProps, selectedEntities: selectedEntitiesCopy }
      this.$emit('input', { ...this.local, watchProps: newWatchProps })
    },
    getEntityDesc (entityId) {
      let result = ''
      let temp = this.groupEntitiesForSelect.find(entity => {
        return entity.id === entityId
      })
      if (temp) {
        result = temp.entityAbbr + ' - ' + this.$chPtObjData('entityChinName', temp)
      }
      return result
    },
    addCCEntity (val) {
      if (!this.local.watchProps.ccEntities.includes(val)) {
        this.local.watchProps.ccEntities.push(val)
        this.entityModel = null
      }
    },
    removeCCEntity (val) {
      const index = this.local.watchProps.ccEntities.indexOf(val)
      if (index > -1) {
        this.local.watchProps.ccEntities.splice(index, 1)
      }
    },
    getCCEntity (entityId) {
      let temp = this.entities.find(entity => {
        return entity.id === entityId
      })
      return temp
    },
    showCopyHandler () {
      this.isShowCopy = !this.isShowCopy
    }
  }
}
</script>
